import { render, staticRenderFns } from "./mob_custom.vue?vue&type=template&id=13ed013a&scoped=true"
import script from "./mob_custom.vue?vue&type=script&setup=true&lang=js"
export * from "./mob_custom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob_custom.vue?vue&type=style&index=0&id=13ed013a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed013a",
  null
  
)

export default component.exports